import ChemistriesReport from "../../pages/chemistries/report";

export const routeChemistriesReport = "/chemistries/report";

export const chemistriesRoutes = [
	{
		path: `${routeChemistriesReport}`,
		element: <ChemistriesReport />,
		permission: "ui.navbar.lab.chemistries.report",
	},
];
